import React from 'react';
import { Outlet, Link } from 'react-router-dom';
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';
import { ArrowLeft } from 'lucide-react'; // Import the arrow left icon

const StoreLayout: React.FC = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      {/* Main content area with padding-top matching header height (80px top bar + 48px nav bar = 128px) */}
      <main className="flex-grow pt-32 relative">
        <div className="absolute top-4 left-4 z-10">
          <Link to="/" className="flex items-center text-gray-600 hover:text-gray-800">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Início
          </Link>
        </div>
        <Outlet /> {/* Renders the matched child route component */}
      </main>
      <Footer /> {/* Optional: Include footer if applicable */}
    </div>
  );
};

export default StoreLayout;
